import React, { useCallback, useEffect, useState } from "react";
import { useGetSimulabDisponibleQuery, useLazyGetSimulabQuePasoQuery } from "../../libs/redux/slices/Simulab/simulabApiSlice";
import Elegirdo from "./Elegirdo";
import Pasolevx from "./Pasolevx";
import Respinst from "./Respinst";
import Pasoacta from "./Pasoacta";
import Quepasox from "./Quepasox";
import { MAILHOG } from "./simulab";
import "../Tablerox/riodo.css";
import "../Tablerox/rioform.css";
import "./simulab.css";

/**
 * SIMULADOR DEL LABORATORIO (Alexandra 2026-10-26): recorrer con las propias manos la Entrega al Transportador (RQ283).
 * Lo que en la vida real hacen otros (la DIAN, el cliente, el Ejecutivo, Customs AI) queda a un clic, en orden, y debajo
 * el «Qué pasó» en lenguaje simple para ver el efecto de cada botón. Solo existe fuera de producción: si el backend
 * responde 404 la pantalla no muestra nada.
 * @param {object} props
 * @param {string} [props.DOCNROXX] DO con que abre (de la URL /laboratorio/:DOCNROXX)
 * @param {Function} [props.onDo] Avisa el DO elegido (para la URL)
 * @author Claude Code (Alexandra Parra) <direccionit.siaco@repremundo.com.co>
 * @since 2026-10-26
 */
const Simulabx = ({ DOCNROXX, onDo }) => {
  const { data: disponible, isError, isLoading } = useGetSimulabDisponibleQuery();
  const [docnroxx, setDocnroxx] = useState(DOCNROXX ?? "");
  const [cargar, { data: foto, isFetching, error }] = useLazyGetSimulabQuePasoQuery();
  const refrescar = useCallback(() => docnroxx && cargar({ DOCNROXX: docnroxx }), [docnroxx, cargar]);
  useEffect(() => {
    refrescar();
  }, [refrescar]);
  const alTerminar = useCallback(() => {
    refrescar();
    //La cola puede emitir el acta o mandar el correo un momento después: segunda mirada
    setTimeout(refrescar, 4000);
  }, [refrescar]);
  if (isLoading || isError || !disponible?.data?.DISPONIBLE) {
    return isLoading ? null : <Nodispon />;
  }
  const elegir = (cDo) => {
    setDocnroxx(cDo);
    onDo?.(cDo);
  };
  return (
    <div className="riodo-escala">
      <div className="riodo sim-cuerpo">
        <Bandasim ambiente={disponible.data.AMBIENTE} />
        <Elegirdo docnroxx={docnroxx} onElegir={elegir} />
        {docnroxx ? <Pasossim docnroxx={docnroxx} foto={foto?.data} alTerminar={alTerminar} /> : null}
        {docnroxx ? <Quepasox foto={foto?.data} cargando={isFetching} error={error} onRefrescar={refrescar} /> : null}
      </div>
    </div>
  );
};

/**
 * Banda superior del panel.
 * @param {object} props
 * @param {string} props.ambiente Ambiente del backend (local, desarrollo, pruebas)
 * @returns {JSX.Element}
 */
const Bandasim = ({ ambiente }) => (
  <div className="rio-band">
    <div>
      <div className="rio-kicker">Herramientas › Laboratorio ({ambiente})</div>
      <div className="rio-band-title">Simulador del laboratorio</div>
      <div className="rio-band-sub">Entrega al transportador: haz tú lo que en la vida real hacen la DIAN, el cliente, el Ejecutivo y Customs AI</div>
    </div>
    <a className="rio-chip" href={MAILHOG} target="_blank" rel="noreferrer">Abrir MailHog (correos de prueba)</a>
  </div>
);

/**
 * Los tres pasos, en orden.
 * @param {object} props
 * @param {string} props.docnroxx DO
 * @param {object} [props.foto] «Qué pasó» actual (transportadores, actas)
 * @param {Function} props.alTerminar Refresca el «Qué pasó»
 * @returns {JSX.Element}
 */
const Pasossim = ({ docnroxx, foto, alTerminar }) => (
  <div className="sim-pasos">
    <Pasolevx docnroxx={docnroxx} alTerminar={alTerminar} />
    <Respinst docnroxx={docnroxx} foto={foto} alTerminar={alTerminar} />
    <Pasoacta docnroxx={docnroxx} foto={foto} alTerminar={alTerminar} />
  </div>
);

/**
 * Aviso cuando el backend dice que el simulador no existe (producción) o no responde.
 * @returns {JSX.Element}
 */
const Nodispon = () => (
  <div className="riodo">
    <div className="rio-card">
      <div className="rio-card-title">Simulador del laboratorio</div>
      <p className="sim-vacio">El simulador no está disponible en este ambiente.</p>
    </div>
  </div>
);

export default Simulabx;
